// Copyright (c) 2017 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import claimNumber from './claim-number';
import {combineReducers} from 'redux';
import debit from './debit';
import debitType from './debit-type';
import debitTypes from './debit-types';
import isConfirmationModalVisible from './confirmation-modal';
import isFullDebitModalVisible from './full-debit-modal';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    claimNumber,
    debit,
    debitType,
    debitTypes,
    isConfirmationModalVisible,
    isFullDebitModalVisible
});



// WEBPACK FOOTER //
// ./src/tcsm/claim-debit/reducers/index.js